// JobApplicationDetailsState.ts
import { Application } from '../../jobApplications/model/JobApplicationsModel';

export interface ToastMessage {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

export interface JobApplicationDetailsState {
  loading: boolean;
  error: string | null;
  application: Application | null;
  withdrawLoading: boolean;
  downloadLoading: boolean;
  toasts: ToastMessage[];
}

export const initialState: JobApplicationDetailsState = {
  loading: true,
  error: null,
  application: null,
  withdrawLoading: false,
  downloadLoading: false,
  toasts: [],
};